import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

/**
 * Which set of disputes to count for per-merchant Won/Lost/Total. Historically
 * this dashboard's Merchants tab counted "all" disputes while the win-rate
 * header counted only AI-touched ones, producing reconcilable-but-confusing
 * numbers. Exposing the choice as a dashboard control makes it explicit.
 */
export const reclaimDenominator = z.enum(["all", "ai-touched"]);
export type ReclaimDenominator = z.infer<typeof reclaimDenominator>;

export const reclaimMerchantRowSchema = z.object({
  teamId: z.string(),
  teamName: z.string(),
  accountId: z.string(),
  totalDisputes: z.number().int(),
  openChargebacks: z.number().int(),
  evidenceGenerated: z.number().int(),
  won: z.number().int(),
  lost: z.number().int(),
  automateEvidenceEnabled: z.boolean(),
  billingEnabled: z.boolean(),
  evidenceGeneratedAmount: z.number(),
});

export interface ReclaimMerchantRow
  extends z.infer<typeof reclaimMerchantRowSchema> {}

export const getReclaimMerchants = unaryRpc({
  name: "getReclaimMerchants" as const,
  input: z.object({ denominator: reclaimDenominator.optional() }),
  output: z.object({
    merchants: z.array(reclaimMerchantRowSchema),
    skippedCount: z.number().int(),
    denominator: reclaimDenominator,
  }),
});
